export enum MailMergeSendCopyMode {
    SaveNone = "SaveNone",
    SaveOne = "SaveOne",
    SaveAll = "SaveAll"
}

export interface MailMergeViewState {
    isMailMerge: boolean;
    /**
     * Tabular recipient data rows, one Map per row keyed by column name → cell value. A Map is used
     * (not a plain object) so column order is preserved even for numeric names like "123", which an
     * object would hoist to the front. The first entry of each row is the recipient email column.
     */
    data: Map<string, string>[];
    /** How draft copies are saved when sending - default is SaveAll */
    sendCopyMode?: MailMergeSendCopyMode;
}
